import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  IconButton
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { getExcludedUrlsApi, addExcludedUrlApi, deleteExcludedUrlApi } from "../../redux/api/clicksApi";
import { message } from "antd";

const ExcludedUrls = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newUrl, setNewUrl] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getExcludedUrlsApi();
      if (res.data?.code === 200) {
        setData(res.data.data);
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to load excluded URLs");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newUrl.trim()) return;
    try {
      const res = await addExcludedUrlApi({ excl_match: newUrl.trim() });
      if (res.data?.code === 200) {
        message.success("Added successfully");
        setNewUrl("");
        fetchData();
      } else {
        message.error(res.data?.failed || "Failed to add");
      }
    } catch (err) {
      message.error("Failed to add excluded URL");
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await deleteExcludedUrlApi({ id });
      if (res.data?.code === 200) {
        message.success("Deleted successfully");
        fetchData();
      } else {
        message.error(res.data?.failed || "Failed to delete");
      }
    } catch (err) {
      message.error("Failed to delete excluded URL");
    }
  };

  return (
    <Box sx={{ padding: "20px" }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Excluded URLs
      </Typography>

      <Paper sx={{ p: 2, mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <form onSubmit={handleAdd} style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '16px' }}>
          <TextField
            size="small"
            label="Add new hostname or pattern to exclude"
            value={newUrl}
            onChange={(e) => setNewUrl(e.target.value)}
            sx={{ flexGrow: 1 }}
          />
          <Button type="submit" variant="contained" color="primary">
            Add
          </Button>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>ID</strong></TableCell>
              <TableCell><strong>Match Pattern / Hostname</strong></TableCell>
              <TableCell align="right"><strong>Action</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={3} align="center">Loading...</TableCell>
              </TableRow>
            ) : data.length > 0 ? (
              data.map((row) => (
                <TableRow key={row.id} hover>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.excl_match}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={() => handleDelete(row.id)} color="error" title="Delete">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">No excluded URLs found</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ExcludedUrls;
